import * as React from 'react';
import { Typography, Grid2 as Grid } from '@mui/material';
import StatsCard from '../elements/stats-card';
import { ViblyStats } from '../../types/blocks/vibly-stats';

interface ViblyStatsProps {
  element: ViblyStats;
}

export const SectionViblyStats: React.FC<ViblyStatsProps> = ({ element }) => (
  <div className="py-16 sm:py-24 md:py-36 space-y-10 md:space-y-20 px-4 md:px-[40px] lg:px-[88px] max-w-[1264px] mx-auto">
    <div className="max-w-[900px] text-center mx-auto">
      <Typography variant="h1">
        {element.title || 'Vibly è la tua risorsa per imparare e crescere musicalmente'}
      </Typography>
    </div>

    {element.stats?.length > 0 && (
      <div>
        <Grid container spacing={{ xs: 1, sm: 2 }} mb={{ xs: 1, sm: 2 }}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <StatsCard
              title={element.stats[0].value}
              subtitle={element.stats[0].label}
              imgSrc="/assets/images/homepage/student-icon.svg"
              imgAlt="icona studente"
              className="bg-primary-light text-primary-dark "
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <StatsCard
              title={element.stats[1].value}
              subtitle={element.stats[1].label}
              imgSrc="/assets/images/homepage/corsi-icon.svg"
              imgAlt="icona corsi"
              className="bg-secondary-light text-secondary-contrastText"
            />
          </Grid>
        </Grid>
        <StatsCard
          title={element.stats[2].value}
          subtitle={element.stats[2].label}
          imgSrc="/assets/images/homepage/people-icon.svg"
          imgAlt="icona persone"
          className="bg-complementary-light text-complementary-contrastText"
        />
      </div>
    )}
  </div>
);
